import { TargetFinancialStatement } from "../CommonModel/TargetFinancialStatement";
import { DatePeriod } from "../CommonModel/BaseModel";
import { BaseRequestModel } from "./BaseRequestModel";
import { FinancialStatementTypes } from "../ResponseModel/FiscalPeriodResponseModel";
import { SelectedFiscalPeriodStateModel } from "../StateModel/FiscalPeriodInfoStateModel";
import { storageModel } from "../CommonModel/StorageModel";
import { CookieAuthenModel } from "../CommonModel/CookieAuthenModel";

export class TransferValuesRequestModel {
    constructor(obj) {
        this.TransferValuesRequest = new TransferValuesRequest(obj.TransferValuesRequest);
        this.CompanyId = obj.CompanyId;
        this.UnitType = obj.UnitType;
        this.Rounding = obj.Rounding;
        this.ApprovalFlowStatus = obj.ApprovalFlowStatus;
    }
}

export class TransferValuesRequest extends BaseRequestModel {
    constructor(obj) {
        super(obj);
        this.PeriodicValueGroups = obj.PeriodicValueGroups.map((item) => { return new PeriodicValueGroup(item) });
        this.ReclassificationType = obj.ReclassificationType;
        this.ValidateErrorLimited = null;
    }
}

export class PeriodicValueGroup {
    constructor(obj) {
        this.YearToDate = new DatePeriod(obj.YearToDate);
        this.AccountingPeriod = new DatePeriod(obj.AccountingPeriod);
        this.TargetFinancialStatement = new TargetFinancialStatement(obj.TargetFinancialStatement)
    }
}

export const ConsolidateType = {
    CN: "Consolidated",
    NC: "NonConsolidated"
}

/**
 * 
 * @param {object} fiscalPeriodModel List fiscalPeriod
 * @param {object} fsStateModel State selected
 * @param {number} unitSelected Unit currency
 * @param {boolean} isReclass ReclassificationType
 * @returns TransferValuesRequestModel
 */
export const CreateTargetFinancialStatementRequest = (fiscalPeriodModel, fsStateModel, unitSelected, isReclass, approvalFlowStatus) => {
    let wiUser = new CookieAuthenModel().GetWILoginModel();
    let indexModel = new SelectedFiscalPeriodStateModel(fsStateModel);

    let targetFiscalPeriod = fiscalPeriodModel.GetFiscalPeriodsByIndex(indexModel.FiscalPeriodIndex);
    let accTypes = fiscalPeriodModel.GetTargetAccountingStandardTypes(indexModel.FiscalPeriodIndex).find(i => i.Value === fsStateModel.AccTypeIndex).Name;

    let targetFinancialStatementTypes = FinancialStatementTypes.map((item) => {
        if (fsStateModel.FsTypeIndex.includes(item.Value))
            return item.Name;
        return null;
    }).filter((el) => {
        return el !== null;
    });;

    let targetPeriodicValueGroups = targetFinancialStatementTypes.map((item) => {
        return new PeriodicValueGroup({
            YearToDate: targetFiscalPeriod.YearToDate,
            AccountingPeriod: targetFiscalPeriod.AccountingPeriod,
            TargetFinancialStatement: {
                AccountingStandardType: accTypes,
                ConsolidationType: ConsolidateType.NC,
                FinancialStatementType: item
            }
        });
    });

    return new TransferValuesRequestModel({
        TransferValuesRequest: new TransferValuesRequest({
            AccessKey: wiUser.AccessKey,
            RequestKey: wiUser.RequestKey,
            PeriodicValueGroups: targetPeriodicValueGroups,
            ReclassificationType: isReclass ? 2 : 1,
            ValidateErrorLimited: null
        }),
        CompanyId: storageModel.GetItem("CompanySelected").Id,
        UnitType: unitSelected,
        Rounding: 0,
        ApprovalFlowStatus: approvalFlowStatus ? 1 : 0
    });
}